import { Link } from "@hyperapp/router";
import { h } from "hyperapp";

import categoriesCSS from "../../common/categories/main.css";

import { controls } from "./controls";

export const main = ({ actions, section, state }): JSX.Element => {
  const { categories, scheduling } = state;

  return (
    <div
      class="container"
      key="scheduling"
      oncreate={() => (
        actions.setSchedulingQueryStringData(), actions.resetScheduling()
      )}
    >
      <div class="mb-3 mt-3">
        {controls({
          actions,
          section,
          state,
        })}
      </div>
      {scheduling.done && !scheduling.sending && (
        <div>
          <div
            class="alert alert-success animated pulse"
            key={`schedulingSucceded::${Math.random()}`}
            role="alert"
          >
            <b>Agendamento realizado!</b>
          </div>
          {Link(
            {
              class: "btn btn-outline-secondary",
              to: state.location.previous,
            },
            <span>
              Voltar para a lista de Locais próximos de{" "}
              <b>{state.unvisitedPlacesNearby.name}</b>
            </span>,
          )}
        </div>
      )}
      {scheduling.lastFetch.failed && (
        <div
          class="alert alert-danger animated pulse"
          key={`schedulingFailed::${scheduling.lastFetch.lastFailure}`}
          role="alert"
        >
          {scheduling.lastFetch.reason.message}
        </div>
      )}
      {scheduling.from && (
        <ul class="list-group mb-3">
          {state[scheduling.from].selected.map(({ categoryID, name }) => {
            const category = categories.find(
              category => category.id === categoryID,
            );

            return (
              <li class="list-group-item">
                <b>{name}</b>
                <br />
                {category ? (
                  <span>{category.name}</span>
                ) : (
                  <span class={categoriesCSS.uncategorized}>
                    <i>Não categorizado</i>
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
